import React, { useEffect, useState } from "react";

import InputLabel from "@mui/material/InputLabel";
import Select from "react-select";

import { doService } from "../../../services/ServiceHelper";
import { getSchoolStudents } from "../../../services/UserService";
import isEmpty from "lodash/isEmpty";

function StudentsSelector({
  school,
  jwt,
  onChange,
  selectedStudents,
  showLabel = true,
}) {
  const [_allStudents, setAllStudents] = useState([]);

  useEffect(() => {
    initStudents();
  }, []);

  const initStudents = () => {
    doService(getSchoolStudents(school, jwt), (results) => {
      const rows = results.data;
      const allStudents = [];

      // put students in buckets
      for (let student of rows) {
        let label = `${student.last_name}, ${student.first_name} `;

        if (!isEmpty(student.mi)) {
          label += ` ${student.mi}.`;
        }
        
        label += ` (${student.grade})`;
        allStudents.push({
          label: label,
          value: student.eid,
        });
      }

      setAllStudents(allStudents);
    });
  };

  const handleChangeStudents = (value) => {
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <>
      {showLabel === true && <InputLabel>Select Student(s) *</InputLabel>}

      <Select
        styles={{
          menu: (provided) => ({
            ...provided,
            zIndex: 1000,
          }),
        }}
        options={_allStudents}
        onChange={handleChangeStudents}
        value={selectedStudents}
        isMulti={true}
      />
    </>
  );
}

export default StudentsSelector;
